var PortafoliosDataGrid;
(function (PortafoliosDataGrid) {
    function positionContextMenu(container, clientX, clientY) {
        if (!container || !container.isConnected || container.classList.contains('d-none'))
            return;
        const menu = container.querySelector('.dropdown-menu');
        if (!menu)
            return;
        const margin = 8;
        const width = document.documentElement.clientWidth;
        const height = document.documentElement.clientHeight;
        container.style.left = '0px';
        container.style.top = '0px';
        menu.style.maxWidth = Math.max(0, width - margin * 2) + 'px';
        menu.style.maxHeight = Math.max(0, height - margin * 2) + 'px';
        const rect = menu.getBoundingClientRect();
        const left = Math.max(margin, Math.min(clientX, width - rect.width - margin));
        const top = Math.max(margin, Math.min(clientY, height - rect.height - margin));
        container.style.left = left + 'px';
        container.style.top = top + 'px';
        container.classList.remove('context-menu-pending');
    }
    PortafoliosDataGrid.positionContextMenu = positionContextMenu;
})(PortafoliosDataGrid || (PortafoliosDataGrid = {}));
